export const BANK_TRANSFER_IN = 'transfer_in'

export const BANK_TRANSFER_OUT = 'transfer_out'

export const BANK_SEPA_IN = 'sepa_in'

export const BANK_SEPA_CANCELED = 'sepa_canceled'

export const BANK_ZAB = 'zab_payment'

export const BANK_TABEO = 'tabeo_payment'

export const BANK_SPLIT_IT = 'splitit_payment'

export const BANK_PLEDG = 'pledg_payment'



// WEBPACK FOOTER //
// ./src/constant/payment-constant.js